// GENERATED by scripts/sync-version.mjs from package.json. Do not edit.
export const VERSION = '0.5.14';
